<main class="container-fluid">

  <!-- Tela principal -->
  <section id="start" class="row d-flex justify-content-center align-items-center text-center bg-second-white">
    <div class="col-md-6 d-flex flex-column justify-content-center align-items-center py-5">
      <h1 class="title">AntecipaGov é com a <span class="text-primary-pink">Broadfactor!</span></h1>
      <p class="my-4">Obtenha o capital para seus projetos <b>antecipando</b>  o recebimento dos seus contratos com o <b>governo</b>.</p>
      <button mat-flat-button (click)="openChat()" class="btn">
        <span>Fale com um consultor</span>
        <mat-icon>
          arrow_outward
        </mat-icon>
      </button>
    </div>
    <figure class="col-md-6 d-block text-end" >
      <img class="d-none d-md-block w-100" src="assets/images/home/person-one.png" alt="Imagem de uma pessoa usando celular">
      <img class="d-block d-md-none w-100" src="assets/images/home/person-one-sm.png" alt="Imagem de uma pessoa usando celular">
    </figure>
  </section>

  <!-- Como funciona | Swiper -->
  <section id="how-it-works" class="d-flex flex-column justify-content-center align-items-center">

    <h1 class="title text-primary-dark-blue text-center">Veja como funciona em <span class="text-primary-pink">5 passos</span></h1>
    <p>
      Com o AntecipaGov, os fornecedores de bens e serviços podem antecipar até 70% dos valores a receber de um contrato com a Administração Pública
    </p>
    <div class="w-100 text-center mb-4">
      <swiper-container init="false" #swiper>
       @for (step of steps; track $index) {
        <swiper-slide>
          <app-card [data]="step"></app-card>
        </swiper-slide>
       }
      </swiper-container>
      <div class="swiper-pagination"></div>
    </div>


    <a
      mat-flat-button
      class="btn"
      [href]="globalConfig.getPlataformUrlList().supplierRegisterUrl" target="_blank"
    >
      <span>Faça seu cadastro</span>
      <mat-icon>
        arrow_outward
      </mat-icon>
    </a>
  </section>

  <!-- Por que a Broadfactor? -->
  <section class="d-flex flex-column justify-content-center align-items-center bg-second-white">
    <div class="container">
      <h1 class="title text-center mb-2">Por que quem fornece para governo escolhe a <span class="text-primary-pink">Broadfactor?</span></h1>
    </div>
    <div class="row my-4">
      <figure class="col-md-5 d-block text-center">
        <img class="mb-4" src="assets/images/home/person-two.png" alt="Imagem de uma mulher">
      </figure>
      <div class="col-md-6 d-flex flex-column justify-content-center align-items-start">
        @for (reason of reasons; track $index) {
          <div class="d-flex justify-content-center align-items-start mb-5">
            <div class="px-2 text-primary-dark-blue">
              <mat-icon class="check-box-icon">check_box</mat-icon>
            </div>
            <div class="reason">
              {{ reason }}
            </div>
          </div>
        }
      </div>
    </div>

    <a class="info-link" [href]=" globalConfig.getDocumentsAwsUrl().credential" target="_blank">Confira nosso registro de regulamentação no governo.</a>
  </section>

  <section class="d-flex flex-column justify-content-center align-items-center">
    <div class="container">
      <h1 class="title text-center mb-2">Financiadores também contam com a <span class="text-primary-pink">Broadfactor!</span></h1>
    </div>
    <div class="row my-4 d-flex justify-content-center align-items-center">
      <figure class="col-md-4 d-block text-center">
        <img class="mb-4"  src="assets/images/home/people.png" alt="Imagem de uma mulher">
      </figure>
      <div class="col-md-7 d-flex flex-column justify-content-center align-items-center">
        <span class="description financier-describe">A Broadfactor é a parceira ideal para potencializar suas operações de compra de recebíveis. Com segurança e eficiência, ajudamos você a aproveitar ao máximo as oportunidades no AntecipaGov.</span>
        <a
          mat-stroked-button
          class="btn"
          [href]="globalConfig.getPlataformUrlList().buyerRegisterUrl" target="_blank"
        >
          <span>Faça seu cadastro de financiador</span>
          <mat-icon>
            arrow_outward
          </mat-icon>
        </a>
      </div>
    </div>
  </section>
  <section class="d-flex flex-column justify-content-center align-items-center">
    <div class="row my-5">
      <div class="col-md-7 d-flex flex-column justify-content-center align-items-center px-4 ">
        <h1 class="title text-justify mb-2">
          <span class="fw-normal">Soluções inteligentes em crédito e serviços financeiros.</span>
          <span class="text-primary-pink"> Somos a  Broadfactor.</span></h1>
        <span class="description text-justify w-100">
          Queremos entender as suas necessidades financeiras para oferecer soluções personalizadas em crédito e serviços financeiros.
        </span>
        <a
          mat-stroked-button
          class="btn text-primary-pink mb-4"
          [href]="globalConfig.getBroadWebsite().mainUrl" target="_blank"
        >
          <span>
            Conheça a Broadfactor
          </span>
          <mat-icon>
            home_work
          </mat-icon>
        </a>
      </div>
      <figure class="col-md-5 d-block text-center ">
        <img class="img-solution" src="assets/images/home/person-three.png" alt="Imagem de uma mulher">
      </figure>
    </div>
  </section>
  <section class="container pb-0">
    <h1 class="text-center title">Ficou com alguma dúvida?</h1>
    <div class="my-5">
      <app-asks-expansion-panel></app-asks-expansion-panel>
    </div>
    <div class="text-center w-100 description">
      <span>Você tem alguma dúvida que não foi respondida aqui? </span>
      <a class="text-primary-dark-blue" routerLink="/central-de-ajuda">Acesse nossa central de ajuda!</a></div>
  </section>

  <section class="d-flex flex-column justify-content-center align-items-center">
    <app-partners></app-partners>
  </section>
</main>

